import { useContext, useState } from "react";
import UBInput from "../../../Libraries/UBInput";
import { LanguageContext } from "../../../context/LanguageContext";
import styles from "./styles.module.css";

const AmountFilterContent = ({
  minValue = "",
  maxValue = "",
  onMinChange,
  onMaxChange,
  onApply,
  minPlaceholder,
  maxPlaceholder,
  applyLabel,
}) => {
  const [I18n] = useContext(LanguageContext);
  minPlaceholder = minPlaceholder || I18n.minimum_amount || "Minimum amount";
  maxPlaceholder = maxPlaceholder || I18n.maximum_amount || "Maximum amount";
  applyLabel = applyLabel || I18n.apply || "APPLY";

  const [error, setError] = useState({
    min: { text: "", show: false },
    max: { text: "", show: false },
    general: { text: "", show: false },
  });

  const validate = () => {
    let errors = {
      min: { text: "", show: false },
      max: { text: "", show: false },
      general: { text: "", show: false },
    };

    const min = Number(minValue);
    const max = Number(maxValue);

    if (minValue && isNaN(min)) {
      errors.min = { text: I18n.invalid_number || "Invalid number", show: true };
    }

    if (maxValue && isNaN(max)) {
      errors.max = { text: I18n.invalid_number || "Invalid number", show: true };
    }

    if (minValue && min < 0) {
      errors.min = { text: I18n.cannot_be_negative || "Cannot be negative", show: true };
    }

    if (maxValue && (max < 0 || max == 0)) {
      errors.max = { text: I18n.cannot_be_negative_or_zero || "Cannot be negative or zero", show: true };
    }

    if (minValue && maxValue && min > max) {
      errors.max = {
        text: I18n.max_should_be_greater_than_min || "Max should be greater than Min",
        show: true,
      };
    }

    setError(errors);

    return !errors.min.show && !errors.max.show && !errors.general.show;
  };
  return (
    <div>
      <form
        id="amount_filter_form"
        className={styles.amountContent}
        onSubmit={(e) => {
          e.preventDefault();
          if (validate()) {
            onApply?.();
          }
        }}
      >
        <UBInput
          inputId="amount_filter_min"
          name="min"
          value={minValue}
          placeholder={minPlaceholder}
          onChange={(name, text) => {
            setError((prev) => ({
              ...prev,
              min: { text: "", show: false },
              general: { text: "", show: false },
            }));
            onMinChange?.(text);
          }}
          inputClassname={styles.amountField}
          baseClassname={styles.amountFieldBase}
          onlyNumbers
          error={error.min}
          autoFocus
        />

        <UBInput
          inputId="amount_filter_max"
          name="max"
          value={maxValue}
          placeholder={maxPlaceholder}
          onChange={(name, text) => {
            setError((prev) => ({
              ...prev,
              max: { text: "", show: false },
              general: { text: "", show: false },
            }));
            onMaxChange?.(text);
          }}
          inputClassname={styles.amountField}
          baseClassname={styles.amountFieldBase}
          onlyNumbers
          error={error.max}
        />

        <div className={styles.amountApplyRow}>
          <button id="amount_filter_apply_btn" type="submit" className={styles.amountApplyButton}>
            {applyLabel}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AmountFilterContent;
